import feedbackApi from "../api/feedbackApi";

class FeedbackService {
    postFeedbackService(B: any, isFileNeeded: boolean, loadedFiles: any) {
        return feedbackApi.postFeedBackApi(B, isFileNeeded, loadedFiles)
    }
}

const feedbackService = new FeedbackService()
export default feedbackService